/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import cn from '../../../../utils/cn';
import { getApiUrl } from '../../../../utils/Env';
import { GetDateTime, GetFileSize } from '../../../../utils/Show';
import { DeleteIcon, DownloadIconLine } from '../../../../utils/SVGIcon';
import { ApiLogsFilesDeleteOpe } from '../LogFilesListOperation';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, handleReload }) {
    const { setConfirm, setMessage } = useTemplate();
    const [isTrActive, setIsTrActive] = useState(false);
    const handleDeleteModalShow = (name) => {
        setConfirm({
            text: 'Are you sure you want to delete this log file?',
            textAction: 'Yes, Delete',
            clickAction: () => {
                ApiLogsFilesDeleteOpe(name)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString(0) });
                    });
            }
        });
    };
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span className="line-clamp-1">{item?.name}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{GetFileSize(item?.size)}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">{GetDateTime(item?.created)}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Date Created"
                    value={GetDateTime(item?.created)}
                    className="sm:hidden"
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <a
                        href={`${getApiUrl()}/api/logs/file/download/${item?.name}`}
                        target="_blank"
                        className="inline-block text-secondary size-8 bg-primary-50 hover:bg-secondary hover:text-white transition-colors rounded-5 p-1.5"
                        rel="noreferrer"
                    >
                        <DownloadIconLine />
                    </a>
                    <span>
                        <button
                            type="button"
                            onClick={() => handleDeleteModalShow(item?.name)}
                            className="size-8 bg-error/20 text-error p-1.5 rounded-5 hover:bg-error hover:text-white transition-colors"
                        >
                            <DeleteIcon />
                        </button>
                    </span>
                </div>
            </div>
        </div>
    );
}

function LogFilesPageTableMobile({ data, handleReload }) {
    return (
        <div className="customer_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow key={item.id} item={item} handleReload={handleReload} />
                    ))
                )}
            </div>
        </div>
    );
}

export default LogFilesPageTableMobile;
